import { Injectable } from '@angular/core';
import { GenericService } from '../generic.service';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DownloadProfileService {

  constructor(private genericService: GenericService) { }

  downloadStudentProdileAsPdf(studentId: string): Observable<HttpResponse<ArrayBuffer>>
  {
    return this.genericService.getBinary(`student/resume/download/${studentId}`);
  }
}
